import React from 'react';

// LocalBusiness Schema für Google
const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "Electrician",
  "@id": "https://www.daniels-gmbh.net/#organization",
  "name": "K.H. und B. Daniels Elektroinstallationen GmbH",
  "alternateName": "Daniels Elektroinstallationen",
  "description": "K.H. und B. Daniels Elektroinstallationen GmbH ist Ihr erfahrener Elektriker in Bonn und im Rhein-Sieg-Kreis – für Elektroinstallationen, Kundendienst, Sprechanlagen von Legrand-Bticino, Modernisierungen und Elektroarbeiten nach DIN-VDE-Normen.",
  "url": "https://www.daniels-gmbh.net",
  "telephone": "+492282346 44",
  "email": "info@daniels-gmbh.net",
  "foundingDate": "1966",
  "priceRange": "€€",
  "image": "https://www.daniels-gmbh.net/logo.png",
  "logo": "https://www.daniels-gmbh.net/logo.png",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Burbacher Straße 177",
    "addressLocality": "Bonn",
    "addressRegion": "Nordrhein-Westfalen",
    "postalCode": "53129",
    "addressCountry": "DE"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "50.6932",
    "longitude": "7.1275"
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Bonn"
    },
    {
      "@type": "AdministrativeArea",
      "name": "Rhein-Sieg-Kreis"
    },
    {
      "@type": "City",
      "name": "Köln"
    },
    {
      "@type": "City",
      "name": "Bornheim"
    },
    {
      "@type": "City",
      "name": "Alfter"
    },
    {
      "@type": "City",
      "name": "Meckenheim"
    }
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Elektroinstallationen",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Altbauinstallationen",
          "description": "Fachgerechte Sanierung und Erneuerung der Elektroinstallation in Altbauten in Bonn"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Modernisierungen",
          "description": "Elektromodernisierung für zeitgemäße Technik, höhere Sicherheit und geringere Energiekosten"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Sprechanlagen von Legrand-Bticino",
          "description": "Planung, Installation und Erweiterung moderner Audio- und Video-Sprechanlagen – inklusive Zugangskontrolle, Infomodulen und 2-Draht-Bus-Technologie."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "SAT- und Empfangsanlagen",
          "description": "Installation von Satelliten- und Empfangsanlagen für kristallklaren Empfang"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "E-Check",
          "description": "Professionelle Prüfung aller elektrischen Anlagen nach aktuellen DIN-VDE-Normen"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Rauchwarnmelder nach DIN 14676",
          "description": "Normgerechte Installation und Wartung von Rauchwarnmeldern"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Nachtspeicherheizungen",
          "description": "Reparatur und Wartung von Elektrospeicher- und Nachtspeicherheizungen"
        }
      }
    ]
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5.0",
    "reviewCount": "3",
    "bestRating": "5"
  },
  "review": [
    {
      "@type": "Review",
      "author": { "@type": "Person", "name": "Va Te" },
      "reviewRating": { "@type": "Rating", "ratingValue": "5" },
      "reviewBody": "Die von uns beim Umzug versehentlich durchbohrte Elektroleitung wurde noch abends im Notdienst repariert. Schnell, freundlich, zuverlässig und faire Preise. Wir können die Firma Daniels absolut empfehlen!"
    },
    {
      "@type": "Review",
      "author": { "@type": "Person", "name": "Peter Bertram" },
      "reviewRating": { "@type": "Rating", "ratingValue": "5" },
      "reviewBody": "Wir waren sehr zufrieden und können die Firma Daniels uneingeschränkt weiterempfehlen. Die Mitarbeiter sind pünktlich, arbeiten sauber und die Preise sind angemessen."
    },
    {
      "@type": "Review",
      "author": { "@type": "Person", "name": "Bonn 1898" },
      "reviewRating": { "@type": "Rating", "ratingValue": "5" },
      "reviewBody": "Sehr freundlich, schnell und saubere Arbeit zum top Preis. Auch bei einem größeren Elektro-Problem im Haus/Altbau findet die Fa. Daniels eine perfekte Lösung."
    }
  ],
  "memberOf": [
    {
      "@type": "Organization",
      "name": "Innung Köln"
    },
    {
      "@type": "Organization",
      "name": "Kreishandwerkerschaft Bonn/Rhein-Sieg"
    }
  ],
  "sameAs": [
    "https://www.instagram.com/elektro.daniels/"
  ]
};

// FAQ Schema
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Was kostet eine Elektroinstallation im Altbau in Bonn?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Die Kosten hängen immer vom Umfang der Arbeiten ab. Nach einem kostenlosen Vor-Ort-Termin erstellen wir Ihnen ein transparentes Angebot – ohne versteckte Kosten. Eine Altbausanierung beginnt in der Regel ab ca. 5.000 €. Ein Festpreis ist je nach Projekt und nach vorheriger Absprache möglich."
      }
    },
    {
      "@type": "Question",
      "name": "Wie lange dauert eine komplette Elektroinstallation einer Modernisierung?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Die Dauer einer Modernisierung hängt von Größe und Umfang des Projekts ab. Eine Standardwohnung in Bonn kann in der Regel innerhalb weniger Arbeitstage vollständig modernisiert werden. Bei größeren Projekten erstellen wir vorab einen detaillierten Zeitplan."
      }
    },
    {
      "@type": "Question",
      "name": "In welchem Gebiet ist Daniels Elektroinstallationen tätig?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Wir sind in Bonn und dem Rhein-Sieg-Kreis tätig: Bonn-Zentrum, Beuel, Bad Godesberg, Bornheim, Alfter, Meckenheim. Auch im Raum Köln vertreten."
      }
    },
    {
      "@type": "Question",
      "name": "Bieten Sie Smart-Home-Lösungen und Sprechanlagen in Bonn an?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Ja, wir planen und installieren moderne Audio- und Video-Sprechanlagen von Legrand-Bticino – inklusive Zugangskontrolle, Infomodulen und 2-Draht-Bus-Technologie. Zusätzlich bieten wir intelligente Lichtsteuerung und vernetzte Haustechnik."
      }
    },
    {
      "@type": "Question",
      "name": "Wie schnell können Sie einen Elektro-Notfall in Bonn beheben?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Bei Elektro-Notfällen während unserer Öffnungszeiten versuchen wir, so schnell wie möglich vor Ort zu sein – in vielen Fällen noch am selben Tag. Rufen Sie uns an unter +49 228 23 46 44. Ein klassischer Notdienst außerhalb der Öffnungszeiten ist nur in Ausnahmefällen und nach vorheriger Absprache möglich."
      }
    },
    {
      "@type": "Question",
      "name": "Gibt es eine Garantie auf die Elektroarbeiten?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Auf alle Installationen geben wir Gewährleistung gemäß den gesetzlichen Bestimmungen. Wir stehen Ihnen auch nach Projektabschluss bei Fragen zur Verfügung."
      }
    }
  ]
};

export default function SEOSchema() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}
